import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import {
	container,
	mrAuto,
	title,
	blackColor,
	whiteColor,
	hexToRgb,
} from "assets/jss/material-kit-pro-react.js";

const headersSection = (theme) => ({
	...headerLinksStyle(theme),
	sectionBlank: {
		height: "70px",
		display: "block",
	},
	container: {
		...container,
		zIndex: "2",
		position: "relative",
		"& h1, & h4, & h6": {
			color: whiteColor,
		},
	},
	conatinerHeader2: {
		...container,
		height: "100%",
		zIndex: "2",
		position: "relative",
		"& h1, & h4, & h6": {
			color: whiteColor,
		},
		paddingTop: "0vh",
	},
	customInput: {
		width: "100%",
		padding: "20px 40px 10px 40px",
	},
	customInputAdd: {
		textAlign: "left",
		width: "100%",
		padding: "0px 20px 0px 40px",
	},
	placeHolderCss: {
		"::placeholder": {
			color: "#97999b",
		},
		color: "#97999b",
	},
	labelTitle: {
		fontSize: "1rem",
		fontWeight: "800",
		color: "#444",
	},
	labelTitleUpdate: {
		fontSize: "0.9rem",
		fontWeight: "500",
		color: "#444",
		textAlign: "left",
		fontFamily: "Rubik-Medium",
		fontWeight: "500",
	},
	description: {
		fontSize: "0.9rem",
		color: "#444",
	},
	labelTitleMain: {
		fontSize: "18px",
		color: "#444",
		textAlign: "left",
		fontFamily: "Rubik-Medium",
		fontWeight: "500",
	},
	errorLabel: {
		fontSize: "0.9rem",
		color: "#f44336",
		textAlign: "left",
	},
	domainIsAvailable: {
		color: "#FFFFFFFF",
		fontWeight: "800",
		backgroundColor: "#53CFC1FF",
		fontSize: "0.8rem",
		textAlign: "left",
		padding: "2px",
	},
	domainIsNotAvailable: {
		color: "#FFFFFFFF",
		fontWeight: "800",
		backgroundColor: "#FF5C93FF",
		fontSize: "0.8rem",
		textAlign: "left",
		padding: "2px",
	},
	tooltip: {
		color: "#FFFFFFFF",
		fontWeight: "800",
		backgroundColor: "#5C72FFFF",
		fontSize: "0.8rem",
		textAlign: "left",
		paddingLeft: "5px",
		paddingRight: "5px",
		padding: "2px",
	},
	subTitle: {
		fontSize: "1rem",
		textTransform: "capitalize",
		textAlign: "left",
		marginBottom: "5px",
	},
	title: {
		...title,
		fontSize: "2rem",
		textAlign: "left",
		marginBottom: "5px",
	},
	pageHeader: {
		position: "relative",
		marginTop: "5px",
		backgroundPosition: "50%",
		backgroundSize: "cover",
		margin: "0",
		padding: "0",
		border: "0",
		display: "flex",
		WebkitBoxAlign: "center",
		MsFlexAlign: "center",
		alignItems: "center",
		"&:before": {
			background: "rgba(" + hexToRgb(blackColor) + ", 0.5)",
		},
		"&:after,&:before": {
			position: "absolute",
			zIndex: "1",
			width: "100%",
			height: "100%",
			display: "block",
			left: "0",
			top: "0",
			content: "''",
		},
	},
	iframeContainer: {
		"& > iframe": {
			width: "100%",
			boxShadow:
				"0 16px 38px -12px rgba(" +
				hexToRgb(blackColor) +
				", 0.56), 0 4px 25px 0px rgba(" +
				hexToRgb(blackColor) +
				", 0.12), 0 8px 10px -5px rgba(" +
				hexToRgb(blackColor) +
				", 0.2)",
		},
	},
	mrAuto,
	textCenter: {
		textAlign: "center",
	},
	card: {
		marginTop: "10px",
	},
	formControl: {
		margin: "0",
		padding: "8px 0 0 0",
	},
	textRight: {
		textAlign: "right",
	},
	button: {
		margin: "0 !important",
	},
});

export default headersSection;
